

<template>
    <DBox 
      :id="'cmp-distribution-supplier-order-setup'"
      :addButton="false"
      :addLink="false"
      :addLinkLabel="`${$t('add_new')} ${$t('address')}`"
      @add_click="onChangeAddress"
    >
        <!-- <Dropdown2

          id="deliver_address_type"
          :label="$dft.capHead($t('Address Type'))"
          :placeholder="'Select ' + $dft.capHead($t('Address Type'))"
          :disabled="false"
         
          :options="addressTypeTV||[]"
          :selected="addressTypeTV.find(e=>e.value==selectedSupplierOrderDetails.order.deliver_address_type)"
          v-on:selectedChange="e => onDropdownChange('deliver_address_type', e)"
        /> -->
        
        <TextField2
          
            id="supplier_name"
            :placeholder="$t('supplier_name')"
            :label="$t('supplier_name')"
            :value="selectedSupplierOrderDetails.supplier_order.supplier_name"
            :disabled="true"
           
            @blur=" e => onTextFieldValueChange(e)"
        />

        <DatePicker2
          :disabled="false"
          id="supplier_order_date"
          :label="$dft.capHead($t('Order Date'))"
          :value="selectedSupplierOrderDetails.supplier_order.supplier_order_date"
          @input="e=>onTextFieldValueChange(e)"
        />

        <Dropdown2

          id="invoice_project_id"
          :label="$dft.capHead($t('invoice_project1'))"
          :placeholder="'Select ' + $dft.capHead($t('invoice_project1'))"
          :disabled="false"
          deselect
          :options="invoiceProjectsTV||[]"
          :selected="invoiceProjectsTV.find(e=>e.value==selectedSupplierOrderDetails.supplier_order.invoice_project_id)"
          v-on:selectedChange="e => onDropdownChange('invoice_project_id', e)"
        />

        <Dropdown2

          id="supply_order_type"
          :label="$dft.capHead($t('supply_order_type'))"
          :placeholder="'Select ' + $dft.capHead($t('supply_order_type'))"
          :disabled="selectedSupplierOrderDetails.supplier_order.supply_order_type==1"
          deselect
          :options="supplyOrderTypesTV||[]"
          :selected="supplyOrderTypesTV.find(e=>e.value==selectedSupplierOrderDetails.supplier_order.supply_order_type)"
          v-on:selectedChange="e => onDropdownChange('supply_order_type', e)"
          :listHeight="250"
        />
        
        <Dropdown2

          id="currency_id"
          :label="$dft.capHead($t('currency'))"
          :placeholder="'Select ' + $dft.capHead($t('currency'))"
          :disabled="false"
          deselect
          :options="currencyTV||[]"
          :selected="currencyTV.find(e=>e.value==selectedSupplierOrderDetails.supplier_order.currency_id)"
          v-on:selectedChange="e => onDropdownChange('currency_id', e)"
        />


        <DatePicker2
          :disabled="false"
          id="estimated_delivery_date"
          :label="$dft.capHead($t('estimated_delivery'))"
          :value="selectedSupplierOrderDetails.supplier_order.estimated_delivery_date"
          @input="e=>onTextFieldValueChange(e)"
        />

        <TextField2
         v-if="selectedSupplierOrderDetails.so_account"    
         id="account_name"
         :placeholder="$t('account_name')"
         :label="$t('account_name')"
         :value="selectedSupplierOrderDetails.so_account.account_name"
          @blur=" e => onTextFieldValueChange(e)"
           
           
            lw="115px"
            cw="280px"
            bb="none"
            
           :icon="'search-blue-padded'"
            @iconClick="searchVatClick"
        />

        <TextField2
         v-if="selectedSupplierOrderDetails.so_product"    
         id="catalog_no"
         :placeholder="$t('catalog_no')"
         :label="$t('catalog_no')"
         :value="selectedSupplierOrderDetails.so_product.catalog_no"
          @blur=" e => onTextFieldValueChange(e)"
           
           
            lw="115px"
            cw="280px"
           
            
            :icon="'search-blue-padded'"
            @iconClick="searchVatClick"
        />

        <TextField2
            v-if="selectedSupplierOrderDetails.so_product"
            id="release_artist"
            :placeholder="$t('release_artist')"
            :label="$t('release_artist')"
            :value="selectedSupplierOrderDetails.so_product.release_artist"
            :disabled="true"
           
            @blur=" e => onTextFieldValueChange(e)"
        />

        <TextField2
            v-if="selectedSupplierOrderDetails.so_product"
            id="release_title"
            :placeholder="$t('release_title')"
            :label="$t('release_title')"
            :value="selectedSupplierOrderDetails.so_product.release_title"
            :disabled="true"
           
            @blur=" e => onTextFieldValueChange(e)"
        />

        <TextField2
            v-if="selectedSupplierOrderDetails.so_product"
            id="format_name"
            :placeholder="$t('format')"
            :label="$t('format')"
            :value="selectedSupplierOrderDetails.so_product.format_name"
            :disabled="true"
             bb="none"
            @blur=" e => onTextFieldValueChange(e)"
        />
     


       
   
    </DBox> 
 
</template>

<script>
import TextField from "@plugins/text-field/text-field";
import Dropdown from "@plugins/dropdown/dropdown";
import { createTextFieldConfig, EventHooks } from "@plugins/text-field";
import { createDropdownConfig } from "@/plugins/dropdown";
import { DistributionStoreNamespace as storeNS } from "../../store";
import { mapActions, mapGetters } from "vuex";
import * as ActionTypes from "../../store/types";
// import AddDeliveryAddress from "./add-delivery-address";
import { createModalMixin, openModalRoute } from "../../../../dt-plugins/modal/modal.mixin";
import { OrderService } from '../../services/order.service';
import { createTV } from '../../../../models/text-value.model';
export default {
  components: {
    TextField,
    Dropdown,
    //AddDeliveryAddress,
  },
  props: {
    selectedSupplierOrderDetails: {
      type: Object,
    },
  },
  data: function () {
    return {
      // Mark: Data
    };
  },
  mounted: function () {},
  watch: {},
  computed: {

    invoiceProjectsTV: function () {
      return createTV(this.selectedSupplierOrderDetails?.invoice_projects||[],"invoice_project_name","invoice_project_id")

    },

    supplyOrderTypesTV :function(){

      const currentOrderType =  this.selectedSupplierOrderDetails.supplier_order.supply_order_type||0;

      const tvArray = currentOrderType==1?this.selectedSupplierOrderDetails?.supply_order_types:this.selectedSupplierOrderDetails?.supply_order_types.filter(x=>x.value!=1)

      return createTV(tvArray||[],"label","value")
    },


    currencyTV:function(){
      return createTV(this.selectedSupplierOrderDetails?.currencies||[],"currency_iso","currency_id")
    }
  },

  methods: {
    onTextFieldValueChange:function (e ) {
      const payload={ 
                      name:e.name ,
                      value:e.value,
                    
                    }
      this.$emit('changed',payload)
  
    },

    onDropdownChange:function(name,e){
      const payload={
                      name:name ,
                      value:e.value,
                    }
      this.$emit('changed',payload)
    },
    searchVatClick:function(){
        if(this.selectedSupplierOrderDetails.so_product){
          this.$router.push({
          ...this.$route,
            query: {
              modal: "add_order_line_modal",
              supplier_order_id:this.selectedSupplierOrderDetails.supplier_order.supplier_order_id,
              so_product:true
            }
          });
        }else{
          this.$router.push({
          ...this.$route,
            query: {
              modal: "add_account_modal",
              supplier_order_id:this.selectedSupplierOrderDetails.supplier_order.supplier_order_id
            }
          });
        }
    },

    onChangeAddress:function(){
         this.$router.push({
          ...this.$route,
          query: {
            modal: "add_contact_relation",
            external_id: this.selectedSupplierOrderDetails.order.order_id,
            external_table: "l_orders",
            key:'delivery_id',
            config_type:"DistributionOrderDeliveryConfig"
          
          },
        });
    }
  },
};
</script>

<style lang="scss" scoped>
.cmp-distribution-supplier-order-setup{

}
// .dt-input-box--container {
//   margin: 5px;
// }
</style>
